import loans from "./loans.component";
import loansUrls from "./loans.urls";
import LoansTransforms from "./loans.transforms";

const loansModule = angular
  .module("app.components.loans", [])
  .component("loansPage", loans)
  .service("LoansTransforms", LoansTransforms)
  .config(loansUrls);

export default loansModule;



// WEBPACK FOOTER //
// ./src/pages/loans/loans.module.js